import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGoogleAdsInit } from "@/ads/hooks/useGoogleAdsInit";
import { Plato } from "@/components";
import { LeaderBoard } from "@/components/Ads";
import { OpenFormStickyBanner } from "@/components/utilsComponents/openFormStickyBanner/OpenFormStickyBanner";
import { PrintTemplateCss } from "@/templates/PrintTemplateCss";
import { useEffect, useState } from "react";
import { CdpPreviewTemplateCSS } from "./CdpPreviewTemplateCss";
import { TemplateDefault } from "./TemplateDefault";
import { Wrapper } from "./Wrapper";
import { usePubstackAdsInit } from "@/components/Ads/hooks/usePubstackAdsInit";
import { useIsPubstackEnabled } from "@/components/Ads/utils/utils";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
const GoogleAdsBootstrap = () => {
    useGoogleAdsInit();
    return null;
};
const PubstackAdsBootstrap = () => {
    usePubstackAdsInit();
    return null;
};
export const TemplateWrapper = () => {
    const [loadPrintTemplate, setLoadPrintTemplate] = useState(false);
    const isPreviewMode = useIsPreviewMode();
    const isPubstackEnabled = useIsPubstackEnabled();
    // saving to local storage after 5 seconds on the page,
    // it prevents showing a 'seen' tag when the user opens the cdp for the first time
    useEffect(() => {
        setLoadPrintTemplate(true);
    }, []);
    return (_jsxs(_Fragment, { children: [!isPubstackEnabled && _jsx(GoogleAdsBootstrap, {}), isPubstackEnabled && _jsx(PubstackAdsBootstrap, {}), isPreviewMode ? _jsx(CdpPreviewTemplateCSS, {}) : null, _jsx(OpenFormStickyBanner, {}), _jsx(LeaderBoard, {}), _jsxs(Wrapper, { children: [loadPrintTemplate && _jsx(PrintTemplateCss, {}), _jsx(TemplateDefault, {})] }), _jsx(Plato, {})] }));
};
